import { useCallback, useEffect, useState } from 'react'
import { useEffectOnce, useLocalStorage } from 'usehooks-ts'
import styled from 'styled-components'

const FooterCredits = ({ tenant }: { tenant?: object }) => {
  const [birthYear, setBirthYear] = useLocalStorage('birthYear', -1)
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 711)
  }

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  useEffect(() => {
    // an eventlistener on the window object that listens for the event 'userBirthyear' and calls the function onHandleBirthyear
    window.addEventListener('userBirthyear', onHandleBirthyear)
    return () => {
      window.removeEventListener('userBirthyear', onHandleBirthyear)
    }
  }, [])

  // the function that is called when the event 'userBirthyear' is fired
  const onHandleBirthyear: any = useCallback((event: CustomEvent) => {
    setBirthYear(event.detail)
  }, [])

  return (
    <>
      {birthYear > 0 && (
        <Footercredits>
          <div className='credit-wrapper'>
            <div className='label'>Avatar Icons</div>
            <div>
              <a href='https://apps.apple.com/us/app/bitface-8-bit-avatar-creator/id687230250'>
                Bitface
              </a>
            </div>
            <div className='label'>Videomaterial</div>
            <div>
              <a href='https://youtube.com/playlist?list=PLjEnTl3TA2mOdHDixzo5lR8FTq5rKTBcA&si=osN6W31GiTDpkOEg'>
                SRF Archiv
              </a>
            </div>
          </div>
        </Footercredits>
      )}
    </>
  )
}

const Footercredits = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.6rem;
  padding: 0 2rem;
  width: 100%;
  margin: 0 auto;
  background-color: var(--site-background);

  .credit-wrapper {
    max-width: 500px;
    margin: 0 auto 6rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    div {
      padding: 0.5rem;
    }
    .label {
      font-weight: 600;
    }
  }
`

export default FooterCredits
